import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import {
    Table, Button, notification, Typography, Row, Col,
    Select, Modal, Tag, Spin, Alert,
    Tooltip,
    Popconfirm
} from 'antd';
import locale from 'antd/es/locale/pt_BR';
import { ExclamationCircleOutlined, DeleteOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useReactToPrint } from 'react-to-print';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
// import { format, addDays } from 'date-fns'
import axios from 'axios';
import {
    urlUsers,
    urlContratoVendedores,
    urlUsersStatusAtivos,
    urlUsersStatusInativos,
    urlUsersStatusTodos,
} from '../../../../services/request/urls';

import { useSelector } from 'react-redux';
import { stateGlobal } from '../../../../interfaces/Global';

import { getToken } from './../../../../services/token';
import Icon from '@ant-design/icons';
import { mask, unMask } from '../../../../utils/MascaraDeCampos';
import { IoArrowUndoSharp } from 'react-icons/io5';
// import { useForm } from 'antd/lib/form/Form';
// import {
//     cardLayout,
//     modalAddModuloInputs,
// } from './GridStyle';
// import {
//     convertDataBrParaUS
// } from './../../../../services/Conversores';

import ModalUsuarioRapido from './../ModalUsuarioRapido'

import { FaWhatsapp } from 'react-icons/fa';
import ModalUsuarioEvento from './../ModalUsuarioEvento';
import { verifyIsSmartphome } from '../../../../utils/VerifyIsSmartphone';
import { useListUsuario } from './useListUsuario';
import { styledRelatorioListUsuario } from './styleRelatorioListUsuario';
import TableWrapperPrint from './components/TableWrapperPrint';
import { useGetColumnSearchProps } from '../../../../hooks/FilterTable/stringCLearFiltros';
import { useGetColumnSearchPropsData } from '../../../../hooks/FilterTable/date';
import { useGetColumnSearchPropsObj } from '../../../../hooks/FilterTable/objString';
import { removeAcento } from '../../../../utils/RemoveAcentos';

const { Text } = Typography;

const IconWhatsApp = (props: any) => <Icon {...props} component={FaWhatsapp} ></Icon>

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

interface tabelaUsuarios {
    id: number,
    uuid: string,
    sistema: string,
    ativo: boolean,
    nome: string,
    celular: string,
    email: string,
    testador: boolean,
    dias_de_teste: string | number | null,
    vendedor: boolean,
    avatar: string | null,
    created_at: string,
    updated_at: string,
    cargo: { id: number, nome: string }
}

const ListUsuarios: React.FC = () => {

    // const formRef = useRef<any>(null);
    // formRef = React.createRef();

    const refValorSelecioneFiltro = React.useRef<string>('Usuários');
    const refContagemDoFiltro = React.useRef<Array<any>>([]);
    const refFuncaoLimparFiltrosString = useRef<any>(null);

    const {
        loadingPage,
        setLoadingPage,
        refComponentToPrint,
        createStyledRetratoOuPaisagem,
    } = useListUsuario();

    const handlePrint = useReactToPrint({
        content: () => refComponentToPrint.current,
        onAfterPrint: () => {
            setLoadingPage(false);
            setShowPrintComponent(false); // Remove o componente após imprimir
            try {
                if (createStyledRetratoOuPaisagem.current && createStyledRetratoOuPaisagem.current.parentNode) {
                    document.head.removeChild(createStyledRetratoOuPaisagem.current);
                    createStyledRetratoOuPaisagem.current = null;
                }
            } catch (error) {
                createStyledRetratoOuPaisagem.current = null;
            }
        },
        onBeforePrint: () => { setLoadingPage(true); },
        documentTitle: `Listagem de Usuários ${new Date().toLocaleDateString("pt-BR")}`
    });

    const handleClickPrint = useCallback(() => {
        setShowPrintComponent(true); // Renderiza o componente antes de imprimir
        applyPrintOrientation('portrait');
    }, []);

    const applyPrintOrientation = (orientation: 'portrait' | 'landscape') => {
        try {
            if (createStyledRetratoOuPaisagem.current && createStyledRetratoOuPaisagem.current.parentNode) {
                document.head.removeChild(createStyledRetratoOuPaisagem.current);
            }
        } catch (error) {
            // Ignora erro se o elemento já foi removido
        }
        createStyledRetratoOuPaisagem.current = document.createElement('style');
        createStyledRetratoOuPaisagem.current.innerHTML = styledRelatorioListUsuario(orientation);
        document.head.appendChild(createStyledRetratoOuPaisagem.current);
    };

    const propsState = useSelector((state: stateGlobal) => state.global);
    const queryParans = useQuery();

    const history = useHistory();
    //para poder cancelar a requisição
    const signal = axios.CancelToken.source();
    const signal1 = axios.CancelToken.source();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string>>([]);
    const [dadosTabelaState, setDadosTabelaState] = useState<Array<tabelaUsuarios>>([]);
    const [dadosFiltradosParaImpressao, setDadosFiltradosParaImpressao] = useState<Array<tabelaUsuarios>>([]);
    const [hasSelectedAdd, setHasSelectedAdd] = useState(true);
    const [hasSelectedView, setHasSelectedView] = useState(false);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);
    const [hasSelectedDel, setHasSelectedDel] = useState(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [valorSelecione, setValorSelecione] = useState('Usuários');

    const [abrirUsuarioRapido, setAbrirUsuarioRapido] = useState(false);
    const [abrirUsuarioEvento, setAbrirUsuarioEvento] = useState(false);

    const [visibleAlertDeAtencaoCache, setVisibleAlertDeAtencaoCache] = useState(false);
    const [spinAlertDeAtencaoCache, setSpinAlertDeAtencaoCache] = useState(false);
    const [ativarOuInativarModulo, setAtivarOuInativarModulo] = useState(false);
    const [showPrintComponent, setShowPrintComponent] = useState(false);

    // Quando o componente de impressão for renderizado, executa o print
    useEffect(() => {
        if (showPrintComponent && refComponentToPrint.current) {
            // Pequeno delay para garantir que o DOM foi atualizado
            const timer = setTimeout(() => {
                handlePrint();
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [showPrintComponent]); // Removida dependência handlePrint para evitar loops

    const buscaDadosTodosusuariosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosVerndedores = async () => {
            try {
                let result = await axios.get(urlUsersStatusTodos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false);

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosVerndedores();

    }, []);

    const buscaDadosUsuariosAtivosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosUsuarios = async () => {
            try {
                let result = await axios.get(urlUsersStatusAtivos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosUsuarios();

    }, []);

    const mensagemDeAtencaoNaTelaPeloCache = useCallback((semParam?: boolean): void => {

        let atencaoParam = queryParans.get("at");
        // comenntado pois não esta utilizando a atualizacao do cache
        // if (
        //     atencaoParam &&
        //     parseInt(atencaoParam)
        //     && parseInt(atencaoParam) === 1
        // ) {
        //     setVisibleAlertDeAtencaoCache(true);
        //     setSpinAlertDeAtencaoCache(true);

        //     setTimeout(() => {
        //         setSpinAlertDeAtencaoCache(false);

        //         // 22 segundos
        //     }, 22000);
        // }

        // if (semParam) {
        //     setVisibleAlertDeAtencaoCache(true);
        //     setSpinAlertDeAtencaoCache(true);

        //     setTimeout(() => {
        //         setSpinAlertDeAtencaoCache(false);

        //         // 15 segundos
        //     }, 15000);
        // }

    }, []);

    const location = useLocation();

    // Função para processar telefone da URL
    const processarTelefoneDaUrl = (telefoneParam: string | null): string[] => {
        if (!telefoneParam) return [];

        let telLimpo = telefoneParam.replace(/\D/g, '');

        if (telLimpo.startsWith('55')) {
            telLimpo = telLimpo.substring(2);
        }

        if (telLimpo.length === 10) {
            telLimpo = telLimpo.substring(0, 2) + '9' + telLimpo.substring(2);
        }

        return [telLimpo];
    };

    // Inicializar filtroCelular baseado nos parâmetros da URL
    const inicializarFiltroCelular = (): string[] => {
        const params = new URLSearchParams(location.search);
        const telefoneParam = params.get('telefone');
        return processarTelefoneDaUrl(telefoneParam);
    };

    const [filtroCelular, setFiltroCelular] = useState<string[]>(inicializarFiltroCelular);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const telefoneParam = params.get('telefone');
        const listagemParam = params.get('listagem');

        if (listagemParam && telefoneParam) {

            const labelFormatado = listagemParam.charAt(0).toUpperCase() + listagemParam.slice(1).toLowerCase();
            setValorSelecione(labelFormatado);
            refValorSelecioneFiltro.current = labelFormatado;

            buscaDadosTodosusuariosAndSetTable();
        } else {
            setValorSelecione('Usuários');
            buscaDadosUsuariosAtivosAndSetTable();
        }
    }, [location.search, buscaDadosTodosusuariosAndSetTable, buscaDadosUsuariosAtivosAndSetTable]);

    //executa apenas quando desmonta o component
    const comonentExecutaAoDestroy = useEffect(() => () => {
        signal.cancel("Requisicao cancelada!")
        signal1.cancel("Requisicao cancelada!")
    }, []);

    const buscaDadosVendedoresAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosVerndedores = async () => {
            try {
                let result = await axios.get(urlContratoVendedores,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false);

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosVerndedores();

    }, []);

    const buscaDadosUsuariosInativosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosUsuarios = async () => {
            try {
                let result = await axios.get(urlUsersStatusInativos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosUsuarios();

    }, []);

    //abrir navegar em add contrato
    const clickBotaoEditarUsuario = useCallback((): void => {

        // const buscaDeDados = async () => {
        const buscaDeDados = () => {

            if (selectedRowKeys.length == 1) {

                let objSelecionado: any = {}
                dadosTabelaState.forEach((dados): void => {
                    if (dados.uuid == selectedRowKeys[0]) {
                        objSelecionado.step1 = dados
                        objSelecionado.idUser = dados.id;
                        objSelecionado.step1.cargo_id = dados.cargo.id;
                    }
                })

                try {
                    // let resultVendedores = await axios.get(urlContratoVendedores + '/' + objSelecionado?.id,
                    //     { headers: { 'Authorization': 'Bearer ' + getToken() } });

                    //     objSelecionado.vendedores = resultVendedores.data;

                    //     let resultEstados = await axios.get(urlContratoEstados + '/' + objSelecionado?.id,
                    //         { headers: { 'Authorization': 'Bearer ' + getToken() } });

                    //     objSelecionado.modo_estado = resultEstados.data;


                    //     objSelecionado.cidades = resultCidades.data;

                    objSelecionado.isEdit = true;

                    localStorage.setItem('@GovFacil:userDataAtualizarESair', JSON.stringify(objSelecionado));
                    localStorage.setItem('@GovFacil:userData', JSON.stringify(objSelecionado));

                    history.push("/usuarios/adicionar");
                } catch (error) {
                    let msgErro: any = (error as Error);
                    notification.error({
                        message: 'Erro',
                        description:
                            msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Erro entre em contato com o suporte!',
                    });
                }

            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState]);

    const requestAtivarOuInativarUser = useCallback((obj): void => {
        setLoadingTable(true);
        const buscaDeDados = async () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id })
                        }
                    });

                })

                try {
                    await axios.patch(urlUsers + "/" + linha[0].id, obj, {
                        //EXEMPLO APENAS PARA EXCLUIR UM [0] ATE CORRIGIR O BACK
                        headers: { 'Authorization': 'Bearer ' + getToken() }
                    })

                    setLoadingTable(false);
                    // if (obj.ativo) {
                    //     buscaDadosUsuariosInativosAndSetTable();
                    // } else {
                    //     buscaDadosUsuariosAtivosAndSetTable();
                    // }

                    if (valorSelecione === 'Usuários') {

                        buscaDadosUsuariosAtivosAndSetTable();

                    } else if (valorSelecione === 'Vendedores') {

                        buscaDadosVendedoresAndSetTable();
                    } else if (valorSelecione === 'Inativos') {

                        buscaDadosUsuariosInativosAndSetTable();
                    } else if (valorSelecione === 'Todos') {

                        buscaDadosTodosusuariosAndSetTable();
                    }

                    mensagemDeAtencaoNaTelaPeloCache(true);

                    notification.success({
                        message: 'Sucesso',
                        description:
                            `O usuario foi ${obj.ativo ? 'ativado' : 'inativado'} com sucesso!`,
                    });
                } catch (error) {
                    setLoadingTable(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            `Não foi possivel
                        ${obj.ativo ? 'ativar' : 'inativar'}
                         o usuario, entre em contato com suporte!`
                    });
                }
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
                setHasSelectedView(false);
                setSelectedRowKeys([]);

            }
        }

        buscaDeDados();
    }, [selectedRowKeys, dadosTabelaState, buscaDadosUsuariosAtivosAndSetTable, buscaDadosUsuariosInativosAndSetTable, valorSelecione]);

    const TextAtivarInativar = (props: any) => <Text>{props.text} <br />Tem certeza que deseja continuar?</Text>;

    const onClickInativarUser = useCallback((): void => {
        Modal.confirm({
            title: 'Cuidado',
            icon: <ExclamationCircleOutlined />,
            content: <TextAtivarInativar text='O usuário perderá todo acesso ao sistema!' />,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAtivarOuInativarUser({ ativo: false });
            },
            onCancel() {
            },
        });
    }, [requestAtivarOuInativarUser]);

    const onClickAtivarUser = useCallback((): void => {
        Modal.confirm({
            title: 'Cuidado',
            icon: <ExclamationCircleOutlined />,
            content: <TextAtivarInativar text='O usuário terá acesso ao sistema novamente!' />,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAtivarOuInativarUser({ ativo: true });
            },
            onCancel() {
            },
        });
    }, [requestAtivarOuInativarUser]);

    //click add usuario
    const navigateAddUser = useCallback((): void => {
        let dadosLocalStorage: string | null = localStorage.getItem('@GovFacil:userData');
        let localUserData: any = null;
        if (typeof dadosLocalStorage == 'string') {
            localUserData = JSON.parse(dadosLocalStorage);
        }

        if (localUserData) {
            localStorage.removeItem('@GovFacil:userData');
        }

        history.push("/usuarios/adicionar");
    }, []);

    const onChangeSelectFiltroBuscaTabela = useCallback((e): void => {
        refValorSelecioneFiltro.current = e
        //setando valor do selecione em stado para caso for inativo renderizar outro botao
        setValorSelecione(e);
        switch (e) {
            case 'Inativos':
                buscaDadosUsuariosInativosAndSetTable();
                break;
            case 'Usuários':
                buscaDadosUsuariosAtivosAndSetTable();
                break;
            case 'Vendedores':
                buscaDadosVendedoresAndSetTable();
                break;
            case 'Todos':
                buscaDadosTodosusuariosAndSetTable();
                break;

            default:
                buscaDadosUsuariosAtivosAndSetTable();
                break;
        }
    }, []);

    //executa ao iniciar e did update para atualizar o botao de ativo ou inativo
    useEffect(() => {
        const buscaDeDados = async () => {
            try {
                if (selectedRowKeys.length === 1) {
                    dadosTabelaState.forEach((objEditar: any): void => {
                        if (objEditar.uuid === selectedRowKeys[0]) {
                            // obj.push(objEditar)
                            setAtivarOuInativarModulo(objEditar.ativo)
                        }
                    })


                }


            } catch (error) {

            }
        }

        buscaDeDados();

    }, [selectedRowKeys]);

    const clickBotaoDeletarDados = useCallback((): void => {
        const requestAsync = () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id })
                        }
                    });

                })

                const excluirDadosModal = async () => {
                    try {
                        setLoadingTable(true)

                        await axios.delete(urlUsers + '/' + linha[0].id, {
                            headers: { 'Authorization': 'Bearer ' + getToken() }
                        })

                        notification.success({
                            message: 'Sucesso',
                            description:
                                'Usuário deletado com sucesso.',
                        });
                        onChangeSelectFiltroBuscaTabela(refValorSelecioneFiltro.current)

                        setLoadingTable(false)

                        setHasSelectedAdd(true);
                        setHasSelectedEdit(false);
                        setSelectedRowKeys([]);
                    } catch (error: any) {
                        setLoadingTable(false)
                        notification.error({
                            message: 'Erro',
                            description:
                                error?.response?.data?.message ? error?.response?.data?.message : 'Não foi possível deletar, entre em contato com suporte!',
                        });
                    }
                }
                excluirDadosModal();

            }
        }

        Modal.confirm({
            className: 'classmodalDadosContatoInatendimento',
            title: 'Atenção',
            icon: <ExclamationCircleOutlined />,
            content: `A exclusão do usuário é irreversível e ele não poderá mais ser encontrado. Deseja realmente excluir?`
            ,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAsync();
            },
            onCancel() {
            },
        });

    }, [selectedRowKeys, dadosTabelaState]);

    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.uuid)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.uuid
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(false);
                setHasSelectedView(true);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(true);
                setHasSelectedView(false);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.uuid]);
                setHasSelectedAdd(false);
                setHasSelectedView(true);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else {
                let teste = selectedRowKeys.concat(record.uuid);
                setSelectedRowKeys(teste);
                setHasSelectedAdd(false);
                setHasSelectedView(false);
                setHasSelectedEdit(false);
                setHasSelectedDel(true);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    const onSelectChange = useCallback((selectedRowKeys): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(false);
            setHasSelectedView(false);
            setHasSelectedEdit(false);
            setHasSelectedDel(true);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(true);
            setHasSelectedView(false);
            setHasSelectedEdit(false);
            setHasSelectedDel(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(false);
            setHasSelectedView(true);
            setHasSelectedEdit(true);
            setHasSelectedDel(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    // Memoizar render de Nome para evitar rerenders desnecessários
    const renderNome = useCallback((nome: any, record: any) => {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                {record.ativo ?
                    <Text>{nome}</Text>
                    :
                    <Text strong style={{ color: '#EB3C54' }}>{nome}</Text>
                }
                {
                    nome ?
                        <Tooltip title="Ir para os acessos" color="blue" key="bluedesvincular">
                            <Button
                                type="primary"
                                size='small'
                                style={{ margin: 2 }}
                                onClick={() => {
                                    history.push(`/relatorios/acessos?idUsuario=${record?.id}&aba=RelAcessosUsuario`)
                                }}
                            >
                                <IoArrowUndoSharp />
                            </Button>
                        </Tooltip>
                        :
                        null
                }
            </div>
        )
    }, [history]);

    // Memoizar render de Contratos
    const renderContratos = useCallback((contratos: any) => (
        <span>
            {
                contratos.map((element: string, index: number) => (
                    <span key={`contrato-${index}`}>
                        <Tag color={''} key={index}>
                            {element}
                        </Tag>
                    </span>
                ))
            }
        </span>
    ), []);

    // Memoizar render de Celular
    const renderCelular = useCallback((celular: any) => {
        let formatedCell: string | null = null
        if (celular) {
            const originalValue = unMask(celular);
            const maskedValue = mask(originalValue, [
                "(99) 9999-9999",
                "(99) 9 9999-9999"
            ]);
            formatedCell = maskedValue;
        }
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                zIndex: 5
            }}>
                <Text>{formatedCell}</Text>
                {
                    celular ?
                        <Button
                            className='botaoWhatsApp_fwebfhewvouyfgvwa'
                            type="primary"
                            size='small'
                            style={{ marginLeft: 5 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                const link = document.createElement('a');
                                link.href = `https://api.whatsapp.com/send/?phone=55${celular.trim()}&text&type=phone_number&app_absent=1`
                                link.target = "_blank";
                                document.body.appendChild(link);
                                link.click();
                            }}
                        >
                            <IconWhatsApp />
                        </Button>
                        :
                        null
                }
            </div >
        )
    }, []);

    // Memoizar sorter de created_at
    const sorterCreatedAt = useCallback((a: any, b: any) => {
        const aMonMen = a.created_at ? moment(a.created_at).unix() : 0;
        const bMonMen = b.created_at ? moment(b.created_at).unix() : 0;
        return aMonMen - bMonMen;
    }, []);

    // Usar hooks globais para filtros de busca
    const columnSearchPropsNome = useGetColumnSearchProps('nome', refFuncaoLimparFiltrosString);
    const columnSearchPropsContratos = useGetColumnSearchProps('contratos', refFuncaoLimparFiltrosString);
    const columnSearchPropsCelular = useGetColumnSearchProps('celular', refFuncaoLimparFiltrosString);
    const columnSearchPropsSistema = useGetColumnSearchProps('sistema', refFuncaoLimparFiltrosString);
    const columnSearchPropsCargo = useGetColumnSearchPropsObj('cargo', 'nome');
    const columnSearchPropsCreatedAt = useGetColumnSearchPropsData('created_at');

    const columns = useMemo(() => {

        return [
            {
                title: 'Nome',
                dataIndex: 'nome',
                ...columnSearchPropsNome,
                width: '10%',
                sorter: (a: any, b: any) => a.nome.localeCompare(b.nome),
                showSorterTooltip: false,
                render: renderNome,
            },
            {
                title: 'Contratos',
                dataIndex: 'contratos',
                ...columnSearchPropsContratos,
                width: '1.5%',
                render: renderContratos,
            },
            {
                title: 'Cargo',
                dataIndex: 'cargo',
                ...columnSearchPropsCargo,
                width: '4%',
                // sorter: (a: any, b: any) => a.created_at.localeCompare(b.created_at),
                render: (cargo: any) => (
                    cargo?.nome
                ),
            },
            {
                defaultFilteredValue: filtroCelular,
                title: 'Celular',
                dataIndex: 'celular',
                ...columnSearchPropsCelular,
                width: '9%',
                render: renderCelular,
            },
            {
                title: 'Sistema',
                dataIndex: 'sistema',
                ...columnSearchPropsSistema,
                width: '2.5%',
                render: (status: any) => (
                    <span>
                        <Tag color={'blue'} key={status}>
                            {status?.toUpperCase()}
                        </Tag>
                    </span>
                ),
            },
            // {
            //     title: 'Status',
            //     dataIndex: 'ativo',
            //     ...getColumnSearchPropsBolean('ativo'),
            //     width: '2%',
            //     render: (status: any) => (
            //         <span>
            //             <Tag color={status ? 'green' : 'red'} key={status}>
            //                 {status ? 'ATIVO' : 'INATIVO'}
            //             </Tag>
            //         </span>
            //     ),
            // },
            // {
            //     title: 'Status cadastro',
            //     dataIndex: 'statusCadastro',
            //     ...getColumnSearchProps('statusCadastro'),
            //     width: '6%',
            //     render: (status: any) => (
            //         <span>
            //             <Tag color={status == "efetivado" ? 'blue' : 'orange'} key={status}>
            //                 {status?.toUpperCase()}
            //             </Tag>
            //         </span>
            //     ),
            // },
            // {
            //     title: 'Período de Teste',
            //     dataIndex: 'validade_teste',
            //     ...getColumnSearchPropsData('validade_teste'),
            //     width: '2%',
            //     sorter: (a: any, b: any) => {

            //         let aMonMen: any = null
            //         let bMonMen: any = null
            //         if (a.validade_teste) {
            //             aMonMen = moment(a.validade_teste).unix()
            //         } else {
            //             aMonMen = 0
            //         }
            //         if (b.validade_teste) {
            //             bMonMen = moment(b.validade_teste).unix()
            //         } else {
            //             bMonMen = 0
            //         }

            //         return aMonMen - bMonMen
            //     },
            //     // sorter: (a: any, b: any) => a.created_at.localeCompare(b.created_at),
            //     render: (validade_teste: any) => {
            //         let data: any = null;
            //         if (validade_teste) {
            //             data = moment(validade_teste).format('DD/MM/YYYY')
            //         }
            //         return (
            //             data
            //         )
            //     },
            // },
            {
                title: 'Criado',
                dataIndex: 'created_at',
                ...columnSearchPropsCreatedAt,
                width: '2%',
                sorter: sorterCreatedAt,
                showSorterTooltip: false,
                render: (criado: any) => moment(criado).format('DD/MM/YYYY HH:mm'),
            },
        ];

    }, [filtroCelular, columnSearchPropsNome, columnSearchPropsContratos, columnSearchPropsCelular, columnSearchPropsSistema, columnSearchPropsCargo, columnSearchPropsCreatedAt, renderNome, renderContratos, renderCelular, sorterCreatedAt]);

    //funcoes user rapido

    const abrirComponentModal = useCallback(() => {
        setAbrirUsuarioRapido(true)
    }, []);

    const fecharComponentModal = useCallback(() => {
        setAbrirUsuarioRapido(false);

        buscaDadosUsuariosAtivosAndSetTable();
    }, []);

    const abrirComponentModalEvento = useCallback(() => {
        setAbrirUsuarioEvento(true)
    }, []);

    const fecharComponentModalEvento = useCallback(() => {
        setAbrirUsuarioEvento(false);

        buscaDadosUsuariosAtivosAndSetTable();
    }, []);

    // Memoizar callbacks da Table para melhorar performance
    const handleTableChange = useCallback((pagination: any, filters: any, sorter: any, extra: any) => {
        refContagemDoFiltro.current = extra.currentDataSource;
        setDadosFiltradosParaImpressao(extra.currentDataSource);
    }, []);

    const renderTableTitle = useCallback((registros: any) => {
        return (
            <div
                style={{
                    backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                    padding: 10,
                    margin: -8,
                    marginBottom: 0.5
                }}
            >
                <Text>
                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                        dadosTabelaState.length :
                        refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                </Text>
            </div>
        )
    }, [propsState.theme, dadosTabelaState.length]);

    const renderTableFooter = useCallback((registros: any) => {
        return (
            <div
                style={{
                    textAlign: 'end'
                }}
            >
                <Text>
                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                        dadosTabelaState.length :
                        refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                </Text>
            </div>
        )
    }, [dadosTabelaState.length]);

    return (
        <>
            <Spin spinning={loadingPage}>
                <div
                    className="header-print-hide"
                    style={{
                        position: 'fixed',
                        zIndex: 2,
                        // paddingTop: 24,
                        // paddingBottom: 10,
                        // paddingLeft: 24,
                        // paddingRight: 10,
                        // margin: -24
                    }}
                >
                    <Row
                    // style={{ marginBottom: 16 }}
                    >
                        <Col>
                            <Button type="primary"
                                style={{ marginRight: 5, marginBottom: 5 }} className="btn_success_vlhbegoawrgbvr" disabled={!hasSelectedAdd}
                                onClick={navigateAddUser}
                            >
                                Adicionar
                            </Button>
                            {/* <Button className="botaoViewUsuarioUser" type="primary" onClick={start} disabled={!hasSelectedView} >
                        Visualizar
                    </Button> */}
                        </Col>
                        <Col>
                            <Button type="primary"
                                style={{ marginRight: 5, marginBottom: 5 }}
                                className="btn_warning_cewuyfgfvewofc" onClick={clickBotaoEditarUsuario} disabled={!hasSelectedEdit}
                            >
                                Editar
                            </Button>
                        </Col>

                        <Col>
                            <Select
                                showSearch
                                placeholder="Selecione..."
                                optionFilterProp="children"
                                style={{ marginRight: 5, marginBottom: 5 }}
                                onChange={onChangeSelectFiltroBuscaTabela}
                                disabled={!hasSelectedAdd}
                                value={valorSelecione}
                                filterOption={(input: any, option: any) => {
                                    let textDigit = removeAcento(input)
                                    let listCidade = removeAcento(option?.children);
                                    return listCidade.indexOf(textDigit) >= 0
                                }}
                            >
                                <Select.Option value="Usuários">Ativos</Select.Option>
                                <Select.Option value="Vendedores">Vendedores</Select.Option>
                                <Select.Option value="Inativos">Inativos</Select.Option>
                                <Select.Option value="Todos">Todos</Select.Option>
                            </Select>
                        </Col>
                        <Col>
                            {selectedRowKeys.length === 1 ?
                                ativarOuInativarModulo ?
                                    <Button type="primary"
                                        style={{ marginRight: 5, marginBottom: 5 }}
                                        danger onClick={onClickInativarUser}
                                        // disabled={!hasSelectedDel}
                                        disabled={!hasSelectedEdit}
                                    >
                                        Inativar
                                    </Button>
                                    :
                                    <Button className="btn_success_vlhbegoawrgbvr"
                                        style={{ marginRight: 5, marginBottom: 5 }}
                                        type="primary" onClick={onClickAtivarUser}
                                        // disabled={!hasSelectedDel}
                                        disabled={!hasSelectedEdit}
                                    >
                                        Ativar
                                    </Button>

                                : <Button type="primary"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    danger onClick={onClickInativarUser}
                                    // disabled={!hasSelectedDel}
                                    disabled
                                >
                                    Inativar
                                </Button>}
                        </Col>
                        <Col>

                            <Popconfirm
                                title="Deseja excluir?"
                                onConfirm={clickBotaoDeletarDados}
                                onCancel={() => { }}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button
                                    // className="botaoDeleteAssociacao"
                                    type="primary"
                                    danger
                                    disabled={!hasSelectedEdit}
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                >
                                    <DeleteOutlined />
                                </Button>
                            </Popconfirm>
                        </Col>
                        <Col>
                            <Button type="primary" style={{ marginRight: 5, marginBottom: 5 }}
                                onClick={() => {
                                    abrirComponentModal();
                                }}>
                                Usuário Rápido
                            </Button>
                        </Col>
                        <Col>
                            <Button type="primary" style={{ marginRight: 5, marginBottom: 5 }}
                                onClick={() => {
                                    abrirComponentModalEvento();
                                }}>
                                Usuário Evento
                            </Button>
                        </Col>
                        <Col>
                            {dadosTabelaState.length > 0 && (
                                <Button
                                    type="primary"
                                    danger
                                    onClick={handleClickPrint}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: 5,
                                        marginBottom: 5,
                                    }}
                                >
                                    {'Imprimir PDF '}
                                    <FilePdfOutlined style={{ fontSize: 22 }} />
                                </Button>
                            )}
                        </Col>
                    </Row>

                </div>
                {
                    visibleAlertDeAtencaoCache &&
                    <Alert
                        message="Atenção"
                        description="Atualizando cache de usuários."
                        type="info"
                        className='marginTopAlertEnsimaTable'
                        style={{
                            marginTop: 50,
                            marginBottom: -40
                        }}
                        showIcon
                        action={
                            <>
                                {
                                    spinAlertDeAtencaoCache ?

                                        <Spin spinning={true} />
                                        :
                                        <Button size="small" onClick={() => {

                                            setVisibleAlertDeAtencaoCache(false);
                                            setSpinAlertDeAtencaoCache(true);

                                            if (valorSelecione === 'Usuários') {

                                                buscaDadosUsuariosAtivosAndSetTable();

                                            } else if (valorSelecione === 'Vendedores') {

                                                buscaDadosVendedoresAndSetTable();
                                            } else if (valorSelecione === 'Inativos') {

                                                buscaDadosUsuariosInativosAndSetTable();
                                            } else if (valorSelecione === 'Todos') {

                                                buscaDadosTodosusuariosAndSetTable();
                                            }
                                        }
                                        } type="primary">
                                            Atualizar
                                        </Button>
                                }
                            </>
                        }
                    />
                }
                <div className='headerAbaixodosBtnTableList_ihabdfvohewvbfopu' />
                <Table
                    // className='marginTopTables'
                    rowClassName={(record) => (record.ativo ? "ativoList" : "inativoList")}
                    rowKey={(record) => record.uuid}
                    loading={loadingTable}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: event => { onclickTable(record, rowIndex) }, // click row
                            onDoubleClick: event => { }, // double click row
                            onContextMenu: event => { }, // right button click row
                            onMouseEnter: event => { }, // mouse enter row
                            onMouseLeave: event => { }, // mouse leave row
                        };
                    }}
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={dadosTabelaState}
                    scroll={{ x: 1000 }}
                    onChange={handleTableChange}
                    title={renderTableTitle}
                    footer={renderTableFooter}
                    size="small"
                    // virtual={false}
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        // showTotal: (total, range) => {
                        //     return (`Mostrando: ${range[0]} ao ${range[1]} num total de ${total} itens`)
                        // },
                        position: ['topRight', 'bottomRight'],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    locale={locale.Table}
                />
                {/* Componente wrapper para impressão - renderizado apenas quando necessário */}
                {showPrintComponent && (
                    <div style={{ display: 'none' }}>
                        <TableWrapperPrint
                            ref={refComponentToPrint}
                            columns={columns}
                            dataSource={dadosFiltradosParaImpressao.length > 0 ? dadosFiltradosParaImpressao : dadosTabelaState}
                            loading={loadingTable}
                            refContagemDoFiltro={refContagemDoFiltro}
                            propsState={propsState}
                        />
                    </div>
                )}
            </Spin>
            {
                abrirUsuarioRapido &&
                <ModalUsuarioRapido visible={abrirUsuarioRapido} setFecharModal={fecharComponentModal} />
            }
            {
                abrirUsuarioEvento &&
                <ModalUsuarioEvento visible={abrirUsuarioEvento} setFecharModal={fecharComponentModalEvento} />
            }

        </>
    );
}

export default ListUsuarios;
